/*
--------------------------------------------------------------------------------------------------------------
Autor:              EMANUEL GUIVAR
Fecha de creacion:  09/04/2025
Sistema:            Web seguros
Descripcion:        Logica para input tipo texto
BITACORA DE CAMBIOS 
--------------------------------------------------------------------------------------------------------------
CODIGO      REQ     ANALISTA                    FECHA       MOTIVO
--------------------------------------------------------------------------------------------------------------
*/
import React, { Fragment, useState } from 'react';

interface InputTextProps {
    name: string,                   // id y name del input
    value: string,                  // valor actual del input
    onChange: onChangeInput,        // funcion que se ejecuta al cambiar opcion elegida
    onBlur: onBlurInput,            // funcion que se ejecutar al salir del input
    type?: string,                  // type del input
    rows?: number,                  // filas del input
    ph?: string,                    // placeholder del input
    feedback?: string,              // mensaje de validacion del input
    max?: number,                   // maximos caracteres
    disabled?: boolean,             // propiedad para deshabilitar el input
};

const InputText = ({ name, value, onChange, onBlur, type = "text", rows = 0, ph = "", feedback = "", max, disabled = false }: InputTextProps) => {

    // controlar input
    const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        event.preventDefault();
        onChange(name, event.target.value);
    };

    // controlar salida
    const handleBlur = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        onBlur(name);
    };

    const inputAttr = {
        id : name,
        name : name,
        value : value,
        onChange : handleChange,
        className : `form-control form-control-sm ${feedback && 'is-invalid'}`,
        placeholder : ph,
        onBlur: handleBlur,
        disabled: disabled, // Aquí se añade el atributo disabled
    };
    
    return (
        <Fragment>
            {rows > 0
                ? <textarea {...inputAttr} rows={rows} maxLength={max}/>
                : <input {...inputAttr} type={type || "text"} />
            }
            {max &&
                <small className="form-text text-muted float-right">Máximo {max} caracteres.</small>
            }
            {feedback.length > 0 && 
                <div className="invalid-feedback d-inline">{feedback}</div>
            }
        </Fragment>
    );
};

export default InputText;